import { useModals, Modal, ModalProps, Button, Input, Stack } from "@skailer-com/uikit";
import { ServerErrorField } from "@/components/server-error-field/ServerErrorField.tsx";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { z } from "zod";

interface InputModalProps extends ModalProps {
  value: number;
  onApply: (value: number) => Promise<void>;
}

export function CandidateAIScoreEditModal({ value, onApply, ...props }: InputModalProps) {
  const { close } = useModals();
  const { id } = { ...props };
  const { t } = useTranslation();

  const SchemaObject = z.object({
    value: z
      .number({ error: t("errors:field_required") })
      .min(0, t("api_errors:minimum_value_must", { minimum: 0 }))
      .max(100, t("api_errors:maximum_value_must", { maximum: 100 })),
  });

  type Schema = z.infer<typeof SchemaObject>;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Schema>({
    mode: "onSubmit",
    resolver: zodResolver(SchemaObject),
    values: {
      value: value,
    },
  });
  const [isLoading, setLoading] = useState<boolean>(false);

  const onSubmit = handleSubmit(async (formData) => {
    setLoading(true);
    await onApply(formData.value);
    close(id);
  });

  return (
    <>
      <Modal
        {...props}
        title={t("ai:edit_score")}
        withCloser
        actions={
          <Stack gap={"sm"}>
            <ServerErrorField errors={errors} />
            <Button type={"submit"} size={"lg"} isLoading={isLoading} onClick={onSubmit}>
              {t("common:save")}
            </Button>
          </Stack>
        }
      >
        <form className="space-y-4 md:space-y-6" onSubmit={onSubmit}>
          <Input
            label={t("ai:match_score")}
            type="number"
            min={0}
            max={100}
            {...register("value", { valueAsNumber: true })}
            error={errors.value?.message}
            autoFocus={true}
          />
        </form>
      </Modal>
    </>
  );
}
